import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Lock, LogIn, Loader2 } from 'lucide-react';

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [username, setU] = useState('admin');
  const [password, setP] = useState('');
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setErr('');
    setLoading(true);
    try {
      await login(username, password);
      nav('/panel-abbasov/dashboard');
    } catch (ex) {
      setErr(ex?.response?.data?.detail || 'Giriş mümkün olmadı');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #1e3d3d 0%, #2f5555 100%)', padding: 20 }}>
      <div style={{ background: '#fff', padding: '40px 36px', borderRadius: 14, width: '100%', maxWidth: 400, boxShadow: '0 20px 60px rgba(0,0,0,0.25)' }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{ width: 60, height: 60, borderRadius: '50%', background: '#17b4b4', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: 12 }}>
            <Lock size={26} color="#fff" />
          </div>
          <h2 style={{ margin: 0, fontSize: 22, fontWeight: 700 }}>Admin Panel</h2>
          <p style={{ margin: '6px 0 0', color: '#6b7280', fontSize: 14 }}>Randevu — idarəetmə paneli</p>
        </div>
        <form onSubmit={submit}>
          <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 6 }}>İstifadəçi adı</label>
          <input value={username} onChange={(e) => setU(e.target.value)} required
            style={{ width: '100%', padding: '10px 14px', border: '1px solid #d1d5db', borderRadius: 8, marginBottom: 14, fontSize: 14, outline: 'none', boxSizing: 'border-box' }} />
          <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 6 }}>Şifrə</label>
          <input type="password" value={password} onChange={(e) => setP(e.target.value)} required
            style={{ width: '100%', padding: '10px 14px', border: '1px solid #d1d5db', borderRadius: 8, marginBottom: 18, fontSize: 14, outline: 'none', boxSizing: 'border-box' }} />
          {err && <div style={{ background: '#fef2f2', border: '1px solid #fecaca', color: '#b91c1c', padding: '8px 12px', borderRadius: 6, fontSize: 13, marginBottom: 14 }}>{err}</div>}
          <button type="submit" disabled={loading}
            style={{ width: '100%', padding: '12px', background: '#17b4b4', color: '#fff', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: loading ? 'wait' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
            {loading ? <Loader2 size={16} className="spin" /> : <LogIn size={16} />}
            Daxil ol
          </button>
        </form>
      </div>
      <style>{`.spin { animation: spin 1s linear infinite; } @keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
